module.exports = __webpack_public_path__ + "img/cooperation_3.51101f3a.jpg";